<template>
  <div class="cb-pmcard__wrap">
    <text-field :type="'card'" ref="ccNumber" @keyup="setCardType" :name="name" @focus="showTestCard($event)" @navigate="navigate()">
      <div class="cb-pmcard__icons cb-pmcard__icons--payment" :class="{'identified': !!selectedCardType}">
        <span v-if="!selectedCardType && pm_list[0].gateway_name == 'CHARGEBEE'">
          <i class="cb-pmcard_icon" :key="card" v-for="card in cards" style="height:20px; width:40px; margin-right:5px"
             :class="getCardClass(card)" />
        </span>
          <template v-if="cardBrands.length > 1">
            <div class="cb-pmcard__icons-wrapper">
                <div v-for="card in cardBrands" :key="card">
                    <div class="cb-pmcard__icon cobrand"  @click=" ()=>handleCardSelect(card)"
                     :class="{selected: selectedCardType === card, dimmed: selectedCardType !== card && selectedCardType}" >
                        <i :class="{[getCardClass(card)]:true}" />
                    </div>
                </div>
              </div>
            </template>
        <transition v-else-if="cardBrands.length>0" name="fade" mode="out-in">
          <i class="cb-pmcard__icon"
                        style="height:20px; width:40px; margin-right:5px; cursor:pointer"
                        :class="getCardClass(cardBrands[0])"
                      />
        </transition>
      </div>
    </text-field>
    <transition name="scale-down-y">
      <div v-show="showCard" class="cb-pmcard__options" :class="{'cb-pmcard__options--top': position}">
        <template v-if="testCards">
          <div ref = "card_options" class="cb-pmcard__option" v-for="(tc, index) in testCards" v-bind:key="index" @keyup.up="navigateUp($event)" @keyup.down="navigateDown($event)" @mousedown="setTestCard(tc)" @keyup.enter="setTestCardKeyBoardEvent($event,tc)" tabindex="0" @blur="blur($event)">
            <div class="cb-pmcard__content">
              <div class="cb-pmcard__title" v-text="tc.name"></div>
              <div class="cb-pmcard__details" v-text="tc.number"></div>
              <div class="cb-pmcard__info" v-text="tc.desc"></div>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
import TextField from "@/components/collections/form/TextField"
import cardFormatter from "@/utils/card-formatter"
import apiClient from '@/utils/cb-client'
import { getHostedShellHeight } from '@/utils/checkout-app-shell'

export default {
  computed: {
     ...mapGetters([
      "pm_list",
      "field_config"
    ]),
    cardPaymentMethod(){
      if(this.pName == "bancontact") {
        return this.$store.getters.pm_by_type("bancontact");
      }
      return this.$store.getters.pm_by_type("card");
    },
    testCards() {
      if(!this.cardPaymentMethod){
        return [];
      }
      return this.cardPaymentMethod.test_cards;
    },
    cards() {
      return cardFormatter.getCardsForLogos();
    }
  },
  props: ['name'],
  data() {
    return {
      pName:"",
      selectedCardType: "",
      showCard: false,
      position: false,
      cardBrands:[],
      defaultSelectedCard:"",
      verificationTranslationKey: "",
      matchedCardType: ""
    }
  },
  components: {
    "text-field": TextField
  },
  created() {
    this.pName = this.findParentForm();
  },
  mounted() {
    const paymentInput = this.$refs.ccNumber.$refs.input;
    cardFormatter.formatCardNumber(paymentInput, {
      blur: this.blur
    });
  },
  methods: {
    setCardType(first, second) {
      /** Vue 3 / callers may pass only a KeyboardEvent; store value may be non-string. */
      let evt = second;
      let raw = first;
      if (first != null && typeof first === 'object' && typeof first.preventDefault === 'function') {
        evt = first;
        const input = this.$refs.ccNumber && this.$refs.ccNumber.$refs && this.$refs.ccNumber.$refs.input;
        raw = input ? input.value : '';
      }
      const value = raw == null ? '' : String(raw);
      this.cardBrands=[];
      this.matchedCardType = cardFormatter.cardType(value);
      if (this.matchedCardType) {
       this.cardBrands.push(this.matchedCardType);
      }
      this.$store.dispatch('set_error', {fname: this.pName, name: "number", error: ''})
      this.$store.dispatch('set_card_bin_info', {});
      const num = value ? value.replace(/\s+/g, "") : "";
      if (!cardFormatter.validateCardNumber(num) || num.length < 12) {
          return this.updateSelectedCardType();
      }
      this.fetchCardBinInfoAndProcess(num, evt);
        
    },
    fetchCardBinInfoAndProcess(number, event) {
      apiClient.hosted_pages.card_bin("", { cardNumber: number })
        .then((binResponse) => {

        this.verificationTranslationKey = "";
        const verificationalInfo = binResponse.verification_info || {};
        this.validateVerificationInfo(verificationalInfo);

        if(this.verificationTranslationKey === 'card.common_decline_reason') {
          return;
        }

        this.defaultSelectedCard = "";
        const supportedLocalCards = this.pm_list[0].supported_local_cards
        const cardBinInfo = binResponse.card_bin_info || [];
        const defaultCards = ['visa', 'mastercard'];

        if (!supportedLocalCards || Object.keys(supportedLocalCards).length === 0 || !this.matchedCardType || !defaultCards.includes(this.matchedCardType)) {
        
          if(event?.code === "Enter") {
            this.$parent.$emit('submit');
          }
          return this.updateSelectedCardType();
        }

        Object.keys(supportedLocalCards).forEach((supportedBrand) => {
        const matchingBrand = cardBinInfo.find((cardInfo) => cardInfo.brand === supportedBrand);
        if (matchingBrand) {
          if (!this.cardBrands.includes(supportedBrand)) {
            this.cardBrands.push(supportedBrand);
          }
          this.defaultSelectedCard = supportedLocalCards[supportedBrand].is_default? supportedBrand: "";
        }
        });
        this.updateSelectedCardType();
        if(event?.code === "Enter") {
            this.$parent.$emit('submit');
          }
        })
        .catch((error) => {
        });
    },
    fetchCardBinInfo(number) {
      return apiClient.hosted_pages.card_bin("", { cardNumber: number });
    },
    blur(event) {
      window.setTimeout(() => {
        if (document.activeElement && document.activeElement.getAttribute("class") != 'cb-pmcard__option' && this.showCard) {
          this.showCard = false;
        }
      })
    },
    calculatePosition() {
      const _this = this.$refs.x;
      const appHeight = getHostedShellHeight();
      if (appHeight - _this.getBoundingClientRect().top < 150) {
        this.position = true;
        this.$refs.dropdownContainer.style.bottom = _this.clientHeight + "px";
        this.$refs.dropdownContainer.style.top = "auto";
      } else {
        this.position = false;
        this.$refs.dropdownContainer.style.top = _this.clientHeight + "px";
        this.$refs.dropdownContainer.style.bottom = "auto";
      }
    },
    showTestCard($event) {
      this.showCard = true;
      if (this.showCard) {
        this.$nextTick(() => {
          window.cbTimeout(() => document.addEventListener('click', this.closeDropDown));
        });
      } else {
        document.removeEventListener('click', this.closeDropDown);
      }
    },
    navigate(){
      this.$refs.card_options && this.$refs.card_options[0].focus();
    },
    navigateDown($event){
      if($event.target && $event.target.nextElementSibling)
        $event.target.nextElementSibling.focus();
    },
    navigateUp($event){
      if($event.target && $event.target.previousElementSibling)
        $event.target.previousElementSibling.focus();
    },
    closeDropDown(event) {
      if(event.target == (this.$refs.ccNumber && this.$refs.ccNumber.$refs.input)){
        return;
      }
      if (this.showCard) {
        this.showCard = false;
      }
      document.removeEventListener('click', this.closeDropDown);
    },
    setTestCardKeyBoardEvent(event,tc){
      event.stopPropagation();
      this.setTestCard(tc);
      if (this.showCard) {
        this.showCard = false;
      }
    },
    validate(name,skipEmpty){
      this.$store.dispatch('validate_field', {
        name: name,
        options: {
          skipEmpty: skipEmpty
        },
        fname: this.pName
      });
    },
    setTestCard(tc){
      let inpMap = {
        "number": tc.number,
        "expiry_year": tc.exp_year && tc.exp_year.length > 2 ? tc.exp_year.substring(2,4) : tc.exp_year,
        "expiry_month": tc.exp_month,
        "cvv": tc.cvv  
      }

      Object.keys(inpMap).forEach(key => {
        if(this.field_config(this.pName, key)) {
          this.validate(key, true);
          this.$store.dispatch('update_form_input', {
            name: key,
            value: inpMap[key],
            formName: this.pName
          });
        }
      });
      if (this.showCard) {
        this.showCard = false;
      }
      this.setCardType(tc.number);
    },
    getCardClass(type) {
      return cardFormatter.getCardClass(type);
    },
    handleCardSelect(card) {
        this.selectedCardType =  card;
        this.$store.dispatch('update_form_input', {
            name: "preferred_scheme",
            value: this.selectedCardType,
            formName: "card"
          });
    },
    updateSelectedCardType() {
        if (this.cardBrands.length === 1) {
          this.selectedCardType = this.cardBrands[0];
        } else {
          this.selectedCardType = "";
          if (this.defaultSelectedCard) {
            this.handleCardSelect(this.defaultSelectedCard);
        }
      }
   },

   validateVerificationInfo(verificationInfo) {
    let cardBinInfoPayload = {};
    let translatedDeclineReason;
    if(Object.keys(verificationInfo).length > 0) {
      const verification_control = verificationInfo['verification_control'];
      let verOutcomeTranslationKey;
      if(verificationInfo.verification_outcome_translation_key) {
        verOutcomeTranslationKey = verificationInfo.verification_outcome_translation_key;
        this.verificationTranslationKey = verOutcomeTranslationKey;
      }
      if(verification_control === 'Decline Payment' && verOutcomeTranslationKey) {
          translatedDeclineReason = this.cmt(verOutcomeTranslationKey);
          this.updateSelectedCardType();
          this.$store.dispatch('set_error', {fname: this.pName, name: "number", error: translatedDeclineReason})
          cardBinInfoPayload['card_decline_reason'] = translatedDeclineReason;
      }
    }
    this.$store.dispatch('set_card_bin_info', cardBinInfoPayload);
   }
  }
}
</script>
<style lang="scss" scoped>
  .cobrand {
    pointer-events: auto;
    cursor: pointer;
    display:flex;
    flex-direction: row;
    padding:0;
    position: relative;

    &.selected {
      opacity: 1;
      transform: scale(1.1);
      transition: transform 0.2s ease, opacity 0.2s ease;
      border: 1.5px solid #2d698a;
      border-radius: 3px;
      padding: 2px 5px;
      &::after {
        content: '\2713';
        position: absolute;
        top: 0px;
        right:0px;
        width: 5px;
        height: 5px;
        font-size: 4px;
        color: #fff;
        background-color: #2d698a;
        display: flex;
       justify-content: center;
       align-items: center;
        border-radius: 0 0 0 1px;
        border: 1px solid #2d698a;
      }

    }
    &.dimmed {
      opacity: 0.5;
      transition: opacity 0.2s ease;
    }
  }
  .cb-pmcard__icons-wrapper{
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
</style>